import React, { Component } from 'react';
import { isMobile, isIos } from '../../static/helper';
import {GA_Event} from '../Analytics/Analytics';
//styles
import './Header.scss';

class Header extends Component {
  constructor() {
    super()
    this.state = {
      isShareActive: false,
      shareUrl: "https://z.ynet.co.il/short/commerce/cocacolares",
    }
    this.activateSharer = this.activateSharer.bind(this);
  }
  activateSharer() {
    this.setState({
      isShareActive: !this.state.isShareActive
    })
  }

  negishut() {
    document.getElementById('INDmenu-btn').click();
    GA_Event("accessibility", "");
  }

  shareFacebook = () => {
    window.open("https://www.facebook.com/share.php?u=" + this.state.shareUrl, '_blank', "width=500,height=300");
    GA_Event("share_from_top_bar", "facebook");
  }
  shareTwitter = () => {
    let title = "#קולהמדינה – התוצאות";
    let description = "תוצאות האמת לבחירות הכלליות של מדינת קוקה-קולה";
    let url = 'https://twitter.com/intent/tweet?text=' + title + " " + description + "%0A" + this.state.shareUrl;
    window.open(url, '_blank', "width=500,height=300");
    GA_Event("Share_Twitter", this.state.shareUrl);
  }
  shareWhatsapp = () => {
    let url = '';
    if (isMobile() || isIos()) {
      url = `whatsapp://send?text=${this.state.shareUrl}`;
      window.open(url, "_parent");
    } else {
      url = `https://api.whatsapp.com/send?phone=&text=${this.state.shareUrl}`
      window.open(url, "_blank");
    }
    // let url = `whatsapp://send?text=${this.state.shareUrl}`;
    // window.open(url, '_blank', "width=500,height=300");
    GA_Event("share_from_top_bar", "whatsapp");
  }

  render() {
    return (
      <header className="header">
        <div className="right">
          <div className="logo"></div>
        </div>
        <div className="left">
          <div className="left-container">
            <ul className={`share${(this.state.isShareActive ? " active " : "")}`}>
              <li className="twitter" onClick={this.shareTwitter}></li>
              <li className="whatsapp" onClick={this.shareWhatsapp}></li>
              <li className="facebook" onClick={this.shareFacebook}></li>
              <li onClick={this.activateSharer} className="sharer"></li>
            </ul>
            <div className="ngishut" onClick={this.negishut}></div>
            <a href="https://www.ynet.co.il/home/0,7340,L-26492,00.html" target="_blank" className="ynet-logo" onClick={() => GA_Event("logo_ynet", "")}></a>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js